module.exports={help:"說明",newAnnouncement:"有新公告",notification:"通知和公告",profile:"個人資料",searchButton:"搜尋",solutionSwitcher:"切換至其他解決方案",unread:"未讀通知"};